import { validateEmail, validatePhoneNumber } from 'utils/validator';

/**
 * Mapping of lead fields with their configurations
 */
export const LEAD_FIELDS = {
  'leadEmail': {
    label: 'Email of Lead',
    key: 'leadEmail',
    required: true,
    description: 'Email address for the contact',
    validate: validateEmail
  },
  'leadName': {
    label: 'Name',
    key: 'leadName',
    required: false,
    description: 'Full name of the contact',
    validate: (value) => {
      // Optional name validation (e.g., no numbers)
      return value ? /^[a-zA-Z\s'-]+$/.test(value) : true;
    }
  },
  'leadPhoneNumber': {
    label: 'Number',
    key: 'leadPhoneNumber',
    required: false,
    description: 'Contact phone number',
    validate: (value) => {
      // For CSV import, accept any phone number format
      return true;
    }
  },
  'leadJobTitle': {
    label: 'Job Title',
    key: 'leadJobTitle',
    required: false,
    description: 'Professional title or position'
  },
  'leadCompany': {
    label: 'Company',
    key: 'leadCompany',
    required: false,
    description: 'Organization or company name',
    validate: (value) => {
      // Optional company name validation
      return value ? value.length <= 100 : true;
    }
  },
  'website': {
    label: 'Website',
    key: 'website',
    required: false,
    description: 'Personal or company website',
    validate: (value) => {
      const websiteRegex = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})[/\w .-]*\/?$/;
      return value ? websiteRegex.test(value) : true;
    }
  },
  'leadAddress': {
    label: 'Location',
    key: 'leadAddress',
    required: false,
    description: 'Address or location information'
  },
  'leadNotes': {
    label: 'Notes',
    key: 'leadNotes',
    required: false,
    description: 'Additional information about the contact'
  }
};

/**
 * Get required lead fields
 * @returns {Array} Array of required field keys
 */
export const getRequiredLeadFields = () => {
  return Object.entries(LEAD_FIELDS)
    .filter(([, config]) => config.required)
    .map(([key]) => key);
};

/**
 * Generate a sample lead import template
 * @returns {Array} Sample lead template
 */
export const generateLeadImportTemplate = () => {
  return [
    {
      'Email of Lead': 'example@email.com',
      'Name': 'John Doe',
      'Number': '+1234567890',
      'Job Title': 'Manager',
      'Company': 'Company Name',
      'Website': 'www.example.com',
      'Location': 'City, Country',
      'Notes': 'Met at the conference'
    }
  ];
};